module.exports = __webpack_public_path__ + "static/media/event-friends-combined-3.07d6d2b6.png";